// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables */
/* Mixins */
/* CSS Rules */
.loan-option {
  background: #FFFFFF;
  border: 1px solid #AFBDCC;
  border-radius: 10px;
  overflow: hidden;
}
.loan-option .caption {
  position: relative;
  padding: 2px 24px 4px 24px;
  background: #EFF3F5;
  border-radius: 0px 0px 1px 1px;
}
.loan-option .caption > span {
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 16px;
  letter-spacing: 0.02em;
  color: #2A2F3C;
}
.loan-option .loan-option-values {
  display: flex;
  flex-direction: row;
}
.loan-option .loan-option-values > * {
  flex: 1 1;
}
.loan-option .loan-option-values > *:first-child {
  flex: 0.75 1;
}
.loan-option .loan-option-values > div {
  padding: 24px 0px 20px 24px;
  display: flex;
  flex-direction: column;
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
}
.loan-option .loan-option-values > div:last-child {
  padding-right: 24px;
}
.loan-option .loan-option-values > div.rate {
  font-weight: 600;
}
.loan-option .loan-option-values > div > span {
  white-space: nowrap;
}
.loan-option .loan-option-values > div > span:first-child {
  font-size: 14px;
  line-height: 16px;
  color: #6E7889;
}
.loan-option .loan-option-values > div > span:last-child {
  padding-top: 6px;
  font-size: 22px;
  line-height: 32px;
  color: #404859;
}`, "",{"version":3,"sources":["webpack://./src/scenes/Private/LoanList/LoanDetails/LoanOption/LoanOption.scss"],"names":[],"mappings":"AAAA,cAAA;AAEA,WAAA;AASA,cAAA;AACA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;AARF;AAUE;EACE,kBAAA;EACA,0BAAA;EAEA,mBAAA;EACA,8BAAA;AATJ;AAWI;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EAxBJ,eAyB0B;EAtBxB,iBAsB8B;EAC5B,sBAAA;EACA,cAAA;AARN;AAYE;EACE,aAAA;EACA,mBAAA;AAVJ;AAYI;EACE,SAAA;AAVN;AAWM;EACE,YAAA;AATR;AAaI;EACE,2BAAA;EAIA,aAAA;EACA,sBAAA;EAEA,oBAAA;EACA,kBAAA;EACA,gBAAA;AAfN;AAOM;EACE,mBAAA;AALR;AAeM;EACE,gBAAA;AAbR;AAgBM;EACE,mBAAA;AAdR;AAgBQ;EA9DN,eA+D8B;EA5D5B,iBA4DkC;EAC5B,cAAA;AAbV;AAgBQ;EACE,gBAAA;EApER,eAqE8B;EAlE5B,iBAkEkC;EAC5B,cAAA;AAbV","sourcesContent":["/* Variables */\n\n/* Mixins */\n@mixin font-size-vh($font-size, $line-height: null) {\n  font-size: $font-size;\n\n  @if $line-height {\n    line-height: $line-height\n  }\n}\n\n/* CSS Rules */\n.loan-option {\n  background: #FFFFFF;\n  border: 1px solid #AFBDCC;\n  border-radius: 10px;\n  overflow: hidden;\n\n  .caption {\n    position: relative;\n    padding: 2px 24px 4px 24px;\n\n    background: #EFF3F5;\n    border-radius: 0px 0px 1px 1px;\n\n    > span {\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 600;\n      @include font-size-vh(10px, 16px);\n      letter-spacing: 0.02em;\n      color: #2A2F3C;\n    }\n  }\n  \n  .loan-option-values {\n    display: flex;\n    flex-direction: row;\n\n    >* {\n      flex: 1;\n      &:first-child {\n        flex: 0.75;\n      }\n    }\n\n    > div {\n      padding: 24px 0px 20px 24px;\n      &:last-child {\n        padding-right: 24px;\n      }\n      display: flex;\n      flex-direction: column;\n\n      font-family: 'Inter';\n      font-style: normal;\n      font-weight: 400;\n\n\n      &.rate {\n        font-weight: 600;\n      }\n\n      > span {\n        white-space: nowrap;\n        \n        &:first-child {\n          @include font-size-vh(14px, 16px);\n          color: #6E7889;\n        }\n\n        &:last-child {\n          padding-top: 6px;\n          @include font-size-vh(22px, 32px);\n          color: #404859;\n        }\n      }\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
